export const appConst = {
    webApiUrl: process.env.VUE_APP_APIURL,
    webClientUrl: process.env.VUE_APP_CLIENTURL,
    webClientPort: process.env.VUE_APP_CLIENTPORT
};
